import "../../CampusSharedComponent/CampusHover/CampusHover.scss"

const CampusHover = ({title,content}) => {
 

  return (
    <>
      <div className='campus-hover' style={{paddingTop:(title.padding)?"15.5px":"12.5px"}}>
      {title && <h2 className='campus-activity-title' >{title.title}</h2>} 
          {content && (
           <div className='campus-activity-container'>
           <div className={title.fourhover ? 'campus-HoverContainer' :
            title.threehover ? 'campus-three-HoverContainer' : title.twohover ? 'campus-two-HoverContainer':" "
           }>
             {
                 content.map((item,index)=><>
                  <div className={title.fourhover ? 'campus-HoverSubcontainer' :
            title.threehover ? 'campus-three-HoverSubcontainer' : title.twohover ? 'campus-two-HoverSubcontainer':" "
           }>
                  <div className='campus-HoverSubcontainer-img'><img src={item.img} alt="" className='campus-HoverSubcontainerimg'></img></div>
                  <div className='campus-HoverBG'>
                    <p>{item.para1}<br></br>{item.para2}</p>
                  </div>
                </div>
                 </>)
             }
           </div>
         </div>
   
          )} 
           </div>
        
    </>
    
  )
}

export default CampusHover